const IN_APP_BROWSER_PATTERN =
	/viber|telegram|whatsapp|fb(ipe|an|av)|line\/|wechat|snapchat|instagram|tiktok|linkedin|twitter|kakao|naver|wv\)/i;

const isStandaloneDisplay = () =>
	typeof window !== 'undefined' &&
	(window.navigator.standalone === true ||
		window.matchMedia?.('(display-mode: standalone)').matches === true);

/**
 * Heuristic: we're likely inside an in-app browser (Viber, Telegram, WhatsApp, etc.)
 * where Google OAuth often fails. Not 100% accurate but good enough to show the banner.
 */
export function isInAppBrowser(
	userAgent = typeof navigator === 'undefined' ? '' : navigator.userAgent,
) {
	if (!userAgent) return false;
	return IN_APP_BROWSER_PATTERN.test(userAgent) && !isStandaloneDisplay();
}
